import { GUEST_WORKSPACE_ROUTE } from '@selfai-platform/shell';

export const GUEST_WORKSPACE_ID = GUEST_WORKSPACE_ROUTE;
export const MY_WORKSPACE_ID = 'my';
